export default __webpack_public_path__ + "static/media/IconDesc_LightsControlPanel.256.06c25f73.png";